import { Box, Button, ButtonProps, Center, Container, Text, Heading, Tab, TabList, TabPanel, TabPanels, Tabs, useDisclosure, Flex, Spacer } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LogosTable from "../../components/table";
import Layout from "../layouts";
import { useNavigate } from "react-router-dom";
import LogosTablePagination from "../../components/table/table-pagination";
import { usePaginator } from "chakra-paginator";
import LogosTableSearch from "../../components/table/table-search";
import VoucherService from "../../services/vouchers/voucher-service";
import LoadingScreen from "../../components/loading-screen";
import Number from "components/number-format";
import moment from "moment";
import BannerService from "../../services/banners/banner-service";

const BannerScene = (): ReactElement => {
    const navigate = useNavigate();
    const [banners, setBanners] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);

        BannerService.GetAll().then((res: any) => {
            if (res.result) {
                setBanners(res.result);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    const handleClickRow = (banner: any) => {
        navigate(`/banners/${banner.id}`);
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Banner</Heading>
                </Box>
                <Flex mt={3}>
                    <Button onClick={() => navigate('/banners/new')}>Buat Banner</Button>
                </Flex>
                <Box mt={6}>
                    <LogosTable
                        headers={[
                            { label: 'Urutan' },
                            { label: 'Nama' },
                            { label: 'Redirect Url' },
                            { label: 'Checkout Url' },
                            { label: 'Halaman Baru?' },
                            { label: 'Aktif?' }]}
                        rows={[
                            { propertyName: 'sequence' },
                            { propertyName: 'name', baseUrl: '/banners/' },
                            {
                                render: (item: any) => {
                                    return <Text>{item.redirectUrl.length > 50 ? `${item.redirectUrl.slice(0, 50)}...` : item.redirectUrl}</Text>
                                }
                            },
                            {
                                render: (item: any) => {
                                    return <Text>{item.checkoutUrl.length > 50 ? `${item.checkoutUrl.slice(0, 50)}...` : item.checkoutUrl}</Text>
                                }
                            },
                            {
                                render: (item: any) => {
                                    return <Text fontWeight={'bold'}>{item.isRedirectToNewWindow ? "Iya" : "Tidak"}</Text>
                                }
                            },
                            {
                                render: (item: any) => {
                                    return <Text fontWeight={'bold'} color={item.status == 0 ? "green" : "red"}>{item.status == 0 ? "Aktif" : "Tidak Aktif"}</Text>
                                }
                            }
                        ]}
                        data={banners}
                        onRowClick={handleClickRow}
                    />
                </Box>
            </Container>
        </Layout >
    );
};

export default BannerScene;